var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-icon-container d-flex align-items-center justify-content-center"},[_c('Icon',{staticClass:"rounded-tick exp-design-bg",class:{ gray: !_vm.isCheck },attrs:{"exp-active":true,"icon":_vm.isCheck ? 'tick' : 'close',"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }